// AZM × Vibrant Spectrum — app JS
// Scroll progress, reveals, hero logo mouse-follow, theme toggle

(function() {
  // ── Scroll progress bar ──
  var bar = document.getElementById('azm-progress-bar');
  if (bar) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
        ticking = false;
      });
    }, { passive: true });
  }

  // ── Reveal animations ──
  function initReveals() {
    var els = document.querySelectorAll('[data-reveal]:not(.revealed)');
    if (!els.length) return;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el) { obs.observe(el); });
  }
  initReveals();
  document.addEventListener('shopify:section:load', initReveals);

  // ── Hero logo mouse-follow ──
  var heroLogo = document.getElementById('azm-hero-logo');
  if (heroLogo) {
    var pos = { x: 0, y: 0 }, target = { x: 0, y: 0 };
    window.addEventListener('mousemove', function(e) {
      var cx = window.innerWidth / 2, cy = window.innerHeight / 2;
      target.x = (e.clientX - cx) / cx * 24;
      target.y = (e.clientY - cy) / cy * 16;
    }, { passive: true });
    (function loop() {
      pos.x += (target.x - pos.x) * 0.06;
      pos.y += (target.y - pos.y) * 0.06;
      heroLogo.style.transform = 'translate(' + pos.x.toFixed(2) + 'px,' + pos.y.toFixed(2) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  // ── Theme toggle (delegated — works with any .azm-theme-toggle) ──
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.azm-theme-toggle');
    if (!btn) return;
    var next = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    localStorage.setItem('azm-theme', next);
  });

  // ── Video gate: pause offscreen + reduced motion ──
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videos = document.querySelectorAll('.azm-hero__video-wrap video, .azm-again__video-wrap video');
  if (reduced) {
    videos.forEach(function(v) { v.pause(); v.removeAttribute('autoplay'); });
  } else if ('IntersectionObserver' in window && videos.length) {
    var vobs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.play().catch(function() {}); }
        else { entry.target.pause(); }
      });
    }, { threshold: 0.1 });
    videos.forEach(function(v) { vobs.observe(v); });
  }
})();
